import {
  ApiResponse,
  handleAxiosError,
  IListOrderFetchParams,
  IListResponse,
  IOrder,
  MN_ORDERS,
} from '@jobcost-monorepo/crud';
import { createRepository } from '@jobcost-monorepo/crud/dto/repositoryFactory';
import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const useJobOrdersFields = () => {
  const { setValue, watch, formState } = useFormContext();
  const jobId = watch('jobId');
  const orderId = watch('orderId');
  const resourceId = watch('id');

  const handleChangeJobId = async () => {
    if (jobId === null || jobId === undefined) {
      setValue('orderId', null);
      return;
    }

    if (formState.dirtyFields['jobId']) {
      const repository = createRepository<IOrder, IListOrderFetchParams>(
        MN_ORDERS,
      );
      const order = await repository
        .getMany({ jobId, resourceId })
        .then((response: ApiResponse<IListResponse<IOrder>>) => {
          if (response?.data && response?.data.data?.length === 1) {
            return response?.data.data[0];
          }
        })
        .catch((err: AxiosError) => handleAxiosError(err));

      if (order) {
        setValue('orderId', order.id, { shouldDirty: true });
      }
    }
  };

  const handleChangeOrderId = async () => {
    if (orderId === null || orderId === undefined) {
      return;
    }

    if (formState.dirtyFields['orderId']) {
      const repository = createRepository<IOrder, IListOrderFetchParams>(
        MN_ORDERS,
      );
      repository
        .get(orderId)
        .then((response: ApiResponse<IOrder>) => {
          if (response?.data) {
            const order = response?.data;
            setValue('resourceId', order?.resourceId, { shouldDirty: true });
          }
        })
        .catch((err: AxiosError) => handleAxiosError(err));
    }
  };

  useEffect(() => {
    handleChangeJobId().then();
  }, [jobId]);

  useEffect(() => {
    handleChangeOrderId().then();
  }, [orderId]);
};

export default useJobOrdersFields;
